"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allOutcomesAvailableForComplexBet = allOutcomesAvailableForComplexBet;
exports.isOutcomeAvailableToBet = isOutcomeAvailableToBet;
exports.getOrdinarBasketOutcomeRestriction = getOrdinarBasketOutcomeRestriction;
exports.getComplexBasketOutcomeRestriction = getComplexBasketOutcomeRestriction;
const constants_1 = require("../../../containers/BasketProvider/constants");
function allOutcomesAvailableForComplexBet(outcomes, options) {
    var _a, _b;
    const eventIds = new Set();
    const checkOnlyOrdinar = (_a = options === null || options === void 0 ? void 0 : options.checkOnlyOrdinar) !== null && _a !== void 0 ? _a : false;
    const checkExclusion = (_b = options === null || options === void 0 ? void 0 : options.checkExclusion) !== null && _b !== void 0 ? _b : false;
    for (const outcome of outcomes) {
        const isAvailableToBet = isOutcomeAvailableToBet(outcome, {
            checkExclusion,
        });
        if (!isAvailableToBet) {
            return false;
        }
        if (checkOnlyOrdinar && outcome.event.onlyOrdinar) {
            return false;
        }
        const duplicatedEvent = eventIds.has(outcome.event.id);
        if (duplicatedEvent) {
            return false;
        }
        else {
            eventIds.add(outcome.event.id);
        }
    }
    return true;
}
function isOutcomeAvailableToBet(outcome, options) {
    var _a;
    const checkExclusion = (_a = options === null || options === void 0 ? void 0 : options.checkExclusion) !== null && _a !== void 0 ? _a : false;
    const isNotExcluded = checkExclusion === false || outcome.event.excluded === false;
    return (isNotExcluded &&
        constants_1.activeEventStatus.includes(outcome.event.status) &&
        constants_1.activeProbabilityStatus.includes(outcome.probability.tradingStatus));
}
function getOrdinarBasketOutcomeRestriction(outcome) {
    if (outcome.event.excluded) {
        return 'excluded';
    }
    return undefined;
}
function getComplexBasketOutcomeRestriction(outcome) {
    if (outcome.event.excluded) {
        return 'excluded';
    }
    if (outcome.event.onlyOrdinar) {
        return 'onlyOrdinar';
    }
    return undefined;
}
//# sourceMappingURL=index.js.map